module.exports = new __parcel__URL__("rumble_icon_svg.1186c0e6.svg").toString();